export type Meta = {
  searchCount: number;
  localityCount: number;
  localityId: number;
  localityName?: string;
  startDate?: string;
  endDate?: string;
};

export const prepareMeta = (meta: any, activitiesCount: number) => {
  const locality = meta.geo_info.locality;

  const result: Meta = {
    searchCount: activitiesCount,
    localityCount: meta.count,
    startDate: meta.start_date,
    endDate: meta.end_date,
    localityId: locality.id,
  };

  if (locality.type === 'city') {
    result.localityName = locality.name;
  }

  return result;
};
